<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>17337558999
          <span class="glyphicon glyphicon-envelope"></span>thwh777888@163.com
          <span class="glyphicon glyphicon-time"></span>服务时间：周一至周六
          6*7小时
        </div>
        <div
          class="shejiao pull-right"
          style="cursor: pointer;"
          @click="showCode = true"
        >
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <div class="header-nav">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="@/assets/images/logo1.png" />
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <span
                v-if="item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="btns" @click="showCode = true">
        <img
          src="@/assets/images/tel.png"
          style="width: 10px;margin-right: 5px;"
        />联系我们
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu ">
        <img
          class="header-nav-m-logo"
          src="@/assets/images/logo1.png"
          alt="短视频KOL资源服务商"
        />
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <button type="button" class="navbar-toggle">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>

        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="mask" v-if="showCode">
      <div class="mask-box">
        <p class="close" @click="showCode = false">✕</p>
        <p>扫描下方对应二维码</p>
        <p>我们会一对一与您交流需求</p>
        <img
          src="http://ht.tinghaiyun.com/themes/simpleboot3/public/assets1/img/d5c3fef893c1faabc70b1c205f9eced7_.png"
          alt="短视频KOL资源服务商"
        />
        <!-- <p style="color: #0096DB;">商务部门微信</p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      showCode: false,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "关于潮生",
          path: "/AboutUs",
          children: []
        },
        {
          name: "多平台推广",
          path: "/Promotion",
          children: []
        },
        {
          name: "行业动态",
          path: "/Dynamic",
          children: []
        },
        {
          name: "一键分发",
          path: "/Distribute",
          children: []
        },
        {
          name: "我们需要你",
          path: "/NeedYou",
          children: []
        },
        {
          name: "个人中心",
          path: "/Login",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #888;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
#header .header-top .shejiao:hover {
  color: #0941ff;
}
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999999;
}
.mask-box {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
  width: 80%;
  max-width: 300px;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
  background: #fff;
}
.mask-box img {
  margin: 0 auto;
}
.close {
  width: 30px;
  height: 30px;
  margin: -20px -20px;
  background: #fff;
  color: #999;
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  opacity: 1;
}
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
}
.btns {
  width: 100px;
  height: 30px;
  background: #0941ff;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
/* 导航栏 */
#header .header-nav {
  height: 70px;
  display: flex;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 156px;
  height: 100%;
  margin-right: 50px;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 156px;
  height: 47px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 70px;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 20px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  padding: 15px 0;
  position: relative;
  cursor: pointer;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #0941ff;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #0941ff;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #0941ff;
  text-decoration: none;
  border-bottom: 2px solid #0941ff;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  #header .header-nav-m .btns {
    position: absolute;
    z-index: 999999;
    left: 50%;
    top: 10px;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo {
    width: 120px;
    line-height: 50px;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #333;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #fff;
    padding: 5px;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #333;
    z-index: 999999;
    font-size: 12px;
  }
  #header .header-nav-m .header-nav-m-menu-wrapper .navbar-toggle {
    border-color: #999;
    margin: 0;
    margin-top: 5px;
  }
  #header .header-nav-m .header-nav-m-menu-wrapper .icon-bar {
    background-color: #999;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    z-index: 9999999;
    background: #f9fbff;
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.08);
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #333;
    font-size: 15px;
    font-weight: bold;
    position: relative;
    display: inline-block;
    width: 100%;
  }
  #header .header-nav-m .header-nav-m-wrapper > li.active {
    border-color: #0941ff;
    background: rgba(0, 115, 255, 0.1);
  }
  #header .header-nav-m .header-nav-m-wrapper > li.active a {
    color: #0941ff;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue